import React  from 'react'

import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import Select from "../../../../../../../core/gd-form/form-element/select-new/select-new"
import CustomView_rowComponent from "./row-component"

type Props = {
    form                    : FormManager
    formFieldName           : string

    dontShowClosedOption?   : boolean

    disabled?               : boolean
}

export default function SelectTaskSystemStatus(props: Props) {
    let systemStatusOptions

    if (props.dontShowClosedOption) {
        systemStatusOptions = [
            {value: 'open',     label: "Open"},
            {value: 'all',      label: "Open & Closed"}
        ]
    } else {
        systemStatusOptions = [
            {value: 'open',     label: "Open"},
            {value: 'closed',   label: "Closed"},
            {value: 'all',      label: "Open & Closed"}
        ]
    }

    return (
        <CustomView_rowComponent label="Task system status">
            <Select form        = {props.form}
                    name        = {props.formFieldName}
                    size        = "big"
                    options     = {systemStatusOptions}
                    disabled    = {props.disabled}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}